import React from 'react';
import Icon from '../AppIcon';
import MirakalousLogo from '../MirakalousLogo';

const Footer = () => {
  return (
    <footer className="relative z-20 text-white py-12 bg-white/10 backdrop-blur-md border-t border-white/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <MirakalousLogo size={40} useImage={true} />
              <div className="flex flex-col">
                <span className="text-lg font-bold leading-tight">Mirakalous Technologies Inc.</span>
                <span className="text-sm font-medium text-white/80 leading-tight">AI Solutions for Smarter Businesses</span>
              </div>
            </div>
            <p className="text-white/80 mb-4">
              Transforming enterprises through secure, scalable AI solutions. Trusted by leading companies worldwide.
            </p>
            <a
              href="https://github.com/kkahol-toronto"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 mt-2 bg-white/10 border border-white/20 backdrop-blur-md px-4 py-2 rounded-lg text-white hover:bg-white/15 enterprise-transition"
              aria-label="Visit our GitHub organization"
            >
              <Icon name="Github" size={18} className="text-white" />
              <span className="text-sm font-semibold">github.com/kkahol-toronto</span>
              <span className="text-xs bg-white/10 px-2 py-0.5 rounded">Open Source</span>
            </a>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Pages</h4>
            <ul className="space-y-2 text-white/80 text-sm">
              <li><a href="/enterprise-ai-solutions-service-architecture" className="hover:text-white enterprise-transition">Solutions</a></li>
              <li><a href="/client-success-stories-quantified-results-gallery" className="hover:text-white enterprise-transition">Success Stories</a></li>
              <li><a href="/technology-stack-infrastructure" className="hover:text-white enterprise-transition">Technology</a></li>
              <li><a href="/security-compliance-hub" className="hover:text-white enterprise-transition">Security</a></li>
              <li><a href="/about-ai-infrastructure-architects" className="hover:text-white enterprise-transition">About</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-white/80 text-sm">
              <li><a href="/contact-consultation-multi-tier-engagement" className="hover:text-white enterprise-transition">Contact</a></li>
              <li><a href="/homepage-enterprise-ai-consulting-hub" className="hover:text-white enterprise-transition">Home</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date()?.getFullYear()} Mirakalous Technologies Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


